import React, { useContext, useEffect, useRef, useState } from "react";


import { Box, Button, Divider, Flex } from "@chakra-ui/react";
import mapboxgl from "mapbox-gl";
import { createPortal } from "react-dom";

import { MapContext } from "./MapContext";

type MapboxPopupProps = {
	latitude: number;
	longitude: number;
	name: string;
	location: string;
	onClick: () => void;
	closeHandle: () => void;
};

export const MapboxPopup: React.FC<MapboxPopupProps> = (props) => {
	const map = useContext(MapContext);
	const popupRef = useRef<mapboxgl.Popup | null>(null);
	const [container] = useState<HTMLDivElement>(() => document.createElement("div"));

	useEffect(() => {
		if (!map) return;

		const popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			anchor: "bottom",
			maxWidth: "none",
		})
			.setLngLat([props.longitude, props.latitude])
			.setDOMContent(container)
			.addTo(map);

		popupRef.current = popup;

		return () => {
			popup.remove();
			popupRef.current = null;
		};
	}, [map, container]);

	useEffect(() => {
		popupRef.current?.setLngLat([props.longitude, props.latitude]);
	}, [props.longitude, props.latitude]);

	return createPortal(
		<Box margin="2rem" width="15rem">
			<Flex flexDirection="row" alignItems="center" marginBottom="1rem" justifyContent="space-between">
				<Flex flexDirection="row" alignItems="center" gap="1rem" fontSize="1.5rem" fontFamily="serif">
					{props.name}
				</Flex>
			</Flex>
			<Divider marginTop="1rem" marginBottom="0.5rem" />
			<Box fontSize="1rem">{props.location}</Box>
			<Button
				minWidth="100%"
				variant="solid"
				marginTop="1rem"
				onClick={() => {
					props.closeHandle();
					props.onClick();
				}}
			>
				Ver más
			</Button>
		</Box>,
		container,
	);
};
